export const intialReportData = {
  should_allow_avoid_tolls: false,
  should_always_find_shortest_distance: false,
  always_report_shortest_distance: false,
};
